//! INSPECT: Not sure why we wrote this ourselves and didn't just take an existing implementation (lodash?)
const isEqual = <T>(obj1: T, obj2: T): boolean => {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) return false;

    if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;

    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return false;

        for (let i = 0; i < obj1.length; i++) {
            if (!isEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
    } else {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false;

        for (const key of keys1) {
            if (!(key in obj2) || !isEqual(obj1[key as keyof typeof obj1], obj2[key as keyof typeof obj2])) {
                return false;
            }
        }
    }

    return true;
};

export default isEqual;
